export { animations } from '@tamagui/config/v5-motion';
